import type {Outcome, OutcomeId} from '../types';
import type {OutcomesAction} from './outcomes-actions';
import {OUTCOMES_REQUESTED, OUTCOMES_UPDATED, OUTCOMES_FAILED} from './outcomes-actions';

export type OutcomesState = {
    isLoading: boolean;
    byId: Partial<Record<OutcomeId, Outcome>>;
    errorMessage: string | null | undefined;
};

const outcomesDefaultState = {
    isLoading: false,
    byId: {},
    errorMessage: null,
} as const;

export const reducer = (
    state: OutcomesState | null | undefined = outcomesDefaultState,
    action: OutcomesAction
): OutcomesState => {
    switch (action.type) {
        case OUTCOMES_REQUESTED: {
            // @ts-ignore
            return {...state, isLoading: true, errorMessage: null};
        }
        case OUTCOMES_UPDATED: {
            const newOutcomes = action.payload.outcomes.reduce(
                (accum, outcome: Outcome) => {
                    accum[outcome.id] = outcome;

                    return accum;
                },
                // @ts-ignore
                {...state.byId}
            );

            // @ts-ignore
            return {
                ...state,
                // $NutshellClientFlowIgnore upgrading Flow to v0.92.1
                byId: newOutcomes,
                isLoading: false,
            };
        }
        case OUTCOMES_FAILED: {
            // @ts-ignore
            return {
                ...state,
                errorMessage: 'We’re having trouble getting your lead outcomes right now.',
                isLoading: false,
            };
        }
        default:
            // @ts-ignore
            return state;
    }
};
